import moment from 'moment'
const TICK_TIME = 5 * 1000 // seconds

export default ctx => {
  let timer

  const handler = () => {
    const { store, router } = ctx
    const { current } = store.state.coaching
    if (!current) return
    const format = 'YYYY-MM-DD'
    const now = moment().format(format)
    const then = moment(current.createdAt).format(format)
    if (now === then) return
    store.dispatch('coaching/expireCoaching')
    window.location.pathname = '/coaching'
  }

  const setup = () => {
    if (timer) return
    timer = setInterval(handler, TICK_TIME)
  }
  setTimeout(setup, TICK_TIME)
}
